import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Link } from '@uhg-abyss/web/ui/Link';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';

const TooltipBody = styled('div', {
  backgroundColor: '#ffffff',
  minWidth: '450px',
  maxWidth: '800px',
  position: 'relative',
  padding: '15px',
  borderRadius: '3px',
});

const UlDots = styled('ul', {
  textAlign: 'center',
  marginTop: 15,
});

const ListDot = styled('li', {
  display: 'inline-block',
  content: '""',
  backgroundColor: '$gray8',
  verticalAlign: 'middle',
  height: 9,
  width: 9,
  margin: '0 5px',
  borderRadius: '50%',

  '&.active': {
    backgroundColor: '$accent1',
  },
});

const ButtonPadding = styled('div', {
  padding: '10px 10px 5px',
});

// fix this
const StyledFooter = styled('div', {
  display: 'flex',
  alignItems: 'flex-end',
  variants: {
    stepStyle: {
      notLastStep: { justifyContent: 'space-between' },
      lastStep: { justifyContent: 'space-around' },
    },
  },
});

const theme = createTheme('uhc', { enterpriseFont: true });

export const TourGuideTooltip = ({
  continuous,
  isLastStep,
  step,
  primaryProps,
  skipProps,
  tooltipProps,
  size,
  index,
}) => {
  const button = continuous && !isLastStep ? 'Next' : 'Close';

  return (
    <ThemeProvider theme={theme}>
      <TooltipBody
        {...tooltipProps}
        style={{ width: step.width || 450, minWidth: step.width || 450 }}
      >
        {step.title && <div>{step.title}</div>}
        {step.content && <div>{step.content}</div>}
        <If condition={size > 1}>
          <UlDots>
            <For each="dot" index="dotIndex" of={[...Array(size)]}>
              <ListDot key={dotIndex} />
            </For>
          </UlDots>
        </If>
        <StyledFooter stepStyle={isLastStep ? 'lastStep' : 'notLastStep'}>
          {!isLastStep && (
            <ButtonPadding>
              <Link
                {...skipProps}
                variant="native"
                data-testid="tour-skip"
                size="14px"
              >
                Done, skip the tour
              </Link>
            </ButtonPadding>
          )}
          <ButtonPadding>
            <Button
              {...primaryProps}
              styles={{
                button: (base) => {
                  return {
                    ...base,
                    paddingLeft: 50,
                    paddingRight: 50,
                  };
                },
              }}
            >
              <div data-testid={button === 'Next' ? 'tour-next' : 'tour-close'}>
                {step.button || button}
              </div>
            </Button>
          </ButtonPadding>
        </StyledFooter>
      </TooltipBody>
    </ThemeProvider>
  );
};

TourGuideTooltip.propTypes = {
  isLastStep: PropTypes.bool.isRequired,
  continuous: PropTypes.bool.isRequired,
  step: PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    content: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    button: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  }).isRequired,
  skipProps: PropTypes.shape({}).isRequired,
  primaryProps: PropTypes.shape({}).isRequired,
  tooltipProps: PropTypes.shape({}).isRequired,
  size: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};
